/**
 * CACHET DE CIRE - Mobile Menu Customization
 * Adds badges and custom colors to specific menu items
 */

(function() {
  'use strict';

  // Configuration des badges et couleurs
  const menuConfig = {
    badges: {
      'Créer mon Sceau': { text: 'POPULAIRE', color: '#c49a6c' },
      'Créer mon sceau': { text: 'POPULAIRE', color: '#c49a6c' },
      'Créer mes cachets de cire': { text: 'POPULAIRE', color: '#c49a6c' },
      'Créer mes cachets': { text: 'POPULAIRE', color: '#c49a6c' },
      'Pistolet à cire': { text: 'POPULAIRE', color: '#c49a6c' },
      'Notre collection de cire': { text: 'PREMIUM', color: '#c49a6c' },
      'Bâtonnets de cire': { text: 'PREMIUM', color: '#c49a6c' }
    },
    colors: {
      'Voir tout': { background: '#faf9f7', textColor: '#1a1a1a' },
      'Nous contacter': { background: '#faf9f7', textColor: '#1a1a1a' },
      'Connexion': { background: '#1a1a1a', textColor: '#ffffff' }
    }
  };

  function customizeMobileMenu() {
    // Sélectionner tous les liens du menu mobile
    const menuDrawer = document.querySelector('#t4s-menu-drawer');
    if (!menuDrawer) return;

    const menuLinks = menuDrawer.querySelectorAll('.t4s-mb__menu a, .t4s-menu-item a');

    menuLinks.forEach(function(link) {
      const linkText = link.textContent.trim();
      
      // Vérifier les badges à ajouter
      Object.keys(menuConfig.badges).forEach(function(menuText) {
        if (linkText.includes(menuText) || linkText === menuText) {
          // Vérifier si le badge existe déjà
          if (!link.querySelector('.t4s-lb_nav_mb')) {
            const config = menuConfig.badges[menuText];
            const badge = document.createElement('span');
            badge.className = 't4s-lb_nav_mb';
            badge.textContent = config.text;
            badge.style.cssText = 'background-color: ' + config.color + ' !important; color: #ffffff !important; margin-left: 8px;';
            
            // Trouver le bon endroit pour insérer le badge
            const textSpan = link.querySelector('.t4s-nav_link_txt');
            if (textSpan) {
              textSpan.appendChild(badge);
            } else {
              link.appendChild(badge);
            }
          }
        }
      });

      // Vérifier les couleurs personnalisées
      Object.keys(menuConfig.colors).forEach(function(menuText) {
        if (linkText === menuText || linkText.trim() === menuText) {
          const config = menuConfig.colors[menuText];
          link.style.backgroundColor = config.background;
          link.style.color = config.textColor;
          
          // Appliquer aussi aux éléments enfants
          const children = link.querySelectorAll('*');
          children.forEach(function(child) {
            if (!child.classList.contains('t4s-lb_nav_mb')) {
              child.style.color = config.textColor;
            }
          });
        }
      });
    });

    // Gérer spécifiquement le lien Connexion (compte)
    const accountLink = menuDrawer.querySelector('.t4s-menu-item-acount a, [href*="account"] a');
    if (accountLink) {
      const config = menuConfig.colors['Connexion'];
      accountLink.style.backgroundColor = config.background;
      accountLink.style.color = config.textColor;
      
      const svg = accountLink.querySelector('svg');
      if (svg) {
        svg.style.color = config.textColor;
      }
    }
  }

  // Observer pour détecter l'ouverture du menu
  function initObserver() {
    const menuDrawer = document.querySelector('#t4s-menu-drawer');
    if (!menuDrawer) {
      // Réessayer si le menu n'est pas encore chargé
      setTimeout(initObserver, 500);
      return;
    }

    // Observer les changements d'attributs (ouverture du menu)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-hidden') {
          const isOpen = menuDrawer.getAttribute('aria-hidden') === 'false';
          if (isOpen) {
            // Petit délai pour laisser le contenu se charger
            setTimeout(customizeMobileMenu, 100);
          }
        }
      });
    });

    observer.observe(menuDrawer, { attributes: true });

    // Aussi observer les sous-menus qui s'ouvrent
    const subMenuObserver = new MutationObserver(function() {
      customizeMobileMenu();
    });

    subMenuObserver.observe(menuDrawer, { 
      childList: true, 
      subtree: true 
    });

    // Exécuter une première fois
    customizeMobileMenu();
  }

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  // Aussi écouter les clics sur le bouton menu
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-drawer-open="menu"]') || 
        e.target.closest('.t4s-site-nav__icon--menu')) {
      setTimeout(customizeMobileMenu, 300);
    }
  });

})();
